import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { applyBranding } from "../lib/helpers";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState({});
  const [locations, setLocations] = useState([]);
  const [services, setServices] = useState([]);
  const [staff, setStaff] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [locationId, setLocationIdState] = useState(localStorage.getItem("mcm_loc") || "");

  const clear = () => {
    setSettings({}); setLocations([]); setServices([]); setStaff([]); setTemplates([]);
    applyBranding({});
  };

  const can = useCallback((perm) => !!user && (user.permissions.includes("*") || user.permissions.includes(perm)), [user]);

  const reload = useCallback(async (u = user) => {
    if (!u || !u.clinic?.is_active) return;
    const has = (p) => u.permissions.includes("*") || u.permissions.includes(p);
    const [s, l, sv, st, tp] = await Promise.all([
      api.get("/settings"), api.get("/locations"), api.get("/services"), api.get("/staff"),
      has("consents.read") ? api.get("/consent-templates") : Promise.resolve({ data: [] }),
    ]);
    setSettings(s.data); setLocations(l.data); setServices(sv.data); setStaff(st.data); setTemplates(tp.data);
    applyBranding(s.data.branding);
  }, [user]);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (user) {
      if (settings.clinic_id && settings.clinic_id !== user.clinic_id) clear();
      reload(user);
    }
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const setLocationId = (id) => {
    localStorage.setItem("mcm_loc", id);
    setLocationIdState(id);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    clear();
    setUser(false);
  };

  const value = { user, setUser, settings, setSettings, locations, services, staff, templates, reload, can, logout,
    locationId: locations.some((l) => l.id === locationId) ? locationId : "", setLocationId };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useApp = () => useContext(Ctx);
